import { includes, trim } from 'lodash';

export const CHANGEABLE_SLAS = ['Despacho a Domicilio', 'Despacho Dinamico'];

export const canChangeSla = (originalSla) => includes(CHANGEABLE_SLAS, originalSla);

export const slaForUpdate = (originalSla, selectedSla) => (
    trim(canChangeSla(originalSla) ? (selectedSla || originalSla) : originalSla)
);

export const sendAddressInPayload = (sla) => includes(sla, 'Despacho');

export const requiresCustomerAddress = (sla = '') => (
    includes(sla, 'Domicilio') || includes(sla, 'Dinamico') || includes(sla, 'Especial')
);
